export const namespace = "history/";
export const SET_LENGTH = "SET_LENGTH";
export const SET_INDEX = "SET_INDEX";
